import React from 'react';
import { Stack, OverlayTrigger, Popover } from 'react-bootstrap';
import { LomavisBadge1 } from '@/lomavisSharedUi/atoms/badges/LomavisBadge1/LomavisBadge1';

interface TagItem {
  id: string;
  title: string;
  variant?: string;
  color?: string;
}

interface LomavisBadgeList1Props {
  items: TagItem[];
  maxVisible?: number;
  onDelete?: (id: string) => void;
  className?: string;
}

export const LomavisBadgeList1: React.FC<LomavisBadgeList1Props> = ({
  items,
  maxVisible = 3,
  onDelete,
  className = ''
}) => {
  const visible = items.slice(0, maxVisible);
  const hidden = items.slice(maxVisible);
  const hiddenCount = hidden.length;

  return (
    <Stack direction="horizontal" gap={2} className={className}>
      {visible.map((item) => (
        <LomavisBadge1
          key={item.id}
          id={item.id}
          title={item.title}
          variant={item.variant}
          color={item.color}
          onDelete={onDelete}
        />
      ))}

      {hiddenCount > 0 && (
        <OverlayTrigger
          trigger={['hover']}
          placement="auto"
          overlay={
            <Popover id="badge-list-popover">
              <Popover.Body className="d-flex flex-wrap gap-1">
                {hidden.map((item) => (
                  <LomavisBadge1
                    key={item.id}
                    id={item.id}
                    title={item.title}
                    variant={item.variant}
                    color={item.color}
                  />
                ))}
              </Popover.Body>
            </Popover>
          }
        >
          <span className="cursor-pointer">
            <LomavisBadge1
              id="more"
              title={`+${hiddenCount}`}
              variant="secondary"
            />
          </span>
        </OverlayTrigger>
      )}
    </Stack>
  );
};
